var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPasteTool = function SvgPasteTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 2.667V1.333h6.666v1.334h2.005c.365 0 .662.296.662.662v10.676a.663.663 0 01-.662.662H2.662A.663.663 0 012 14.005V3.329c0-.366.297-.662.662-.662h2.005zm0 1.333H3.333v9.333h9.334V4h-1.334v1.333H4.667V4zM6 2.667V4h4V2.667H6z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paste-tool_svg__clip0_230_3030"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgPasteTool;